import { render, staticRenderFns } from "./ReportItem.vue?vue&type=template&id=0ab8c64e&scoped=true&"
import script from "./ReportItem.vue?vue&type=script&lang=js&"
export * from "./ReportItem.vue?vue&type=script&lang=js&"
import style0 from "./ReportItem.vue?vue&type=style&index=0&id=0ab8c64e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab8c64e",
  null
  
)

export default component.exports